import { render, staticRenderFns } from "./TablaSimTodos.vue?vue&type=template&id=2c45146e&"
import script from "./TablaSimTodos.vue?vue&type=script&lang=ts&"
export * from "./TablaSimTodos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports